import { AxiosResponse } from 'axios';
import client from '../../lib/service/order.service';
import { CouponResponse, Coupon, CouponRequest } from './coupons.types';
import { subscribeComponentToErrorCode } from '@ferreri/minato-error-handler-react';
import { InvalidCouponError } from './InvalidCouponError';
import { CouponNotFoundError } from './CouponNotFoundError';

const COUPONS = 'v1/coupons';
const ORDER_COUPON = 'v1/coupon';
const COUPON = (promocode: string) => `${COUPONS}/${promocode}`;

export const getCoupon = async (promocode: string): Promise<Coupon> => {
  const response = await client.get<Coupon, AxiosResponse<CouponResponse>>(
    COUPON(promocode),
  );
  return response.data.coupon;
};

export const updateOrderCoupon = async (
  promocode: string,
  orderUuid: string,
): Promise<Coupon> => {
  const response = await client.put<
    CouponRequest,
    AxiosResponse<CouponResponse>
  >(
    ORDER_COUPON,
    {
      coupon: {
        promocode,
      },
    },
    {
      headers: {
        'order-uuid': orderUuid,
      },
    },
  );
  return response.data.coupon;
};

subscribeComponentToErrorCode('InvalidCouponError', InvalidCouponError);
subscribeComponentToErrorCode('ExpiredCouponError', CouponNotFoundError);
subscribeComponentToErrorCode('CouponNotAllowedError', CouponNotFoundError);
subscribeComponentToErrorCode('CouponNotFoundError', CouponNotFoundError);
